<template>
	<div>
		<section v-if="!Hazir" class="home-two-slide d-flex align-items-center" style="margin-top: 131px; justify-content:center">
			<div class="row ">
			<span  class="loader"></span>
			</div>
		</section>


		<section v-if="getRol =='student' && OgrenimAraclari.length > 0" class="topcategory-sec">
			<div class="container">
				<div class="header-two-title text-center" data-aos="fade-up">
					<p class="tagline" style="margin-bottom: -1rem;" :style="Text1StyleObject">Online Learning Tools</p>
					<!-- <h2>Top Category</h2> -->
					<div class="header-two-text">
						<!-- <p class="mb-0">Lorem ipsum dolor sit amet</p> -->
					</div>
				</div>
				<div class="top-category-group">
					
					<div class="row" style="justify-content: center;">
						<span v-if="!Hazir" class="loader"></span>
						<!-- <template v-if="Hazir && OgrenimAraclari.length > 0"> -->
						<template v-if="(Hazir && OgrenimAraclari.length > 0)">
							<div v-for="(item) in OgrenimAraclari" :key="`l-`+item.UrunId" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-flex" data-aos="fade-down">
								<div class="categories-item flex-fill" :style="CardStyleObject" 
								@click="item.UrunId == 10 ? RLPModalGosterKapat(item) : git_LearningTools(item)">
									<div style="height: 100px;">	
										<div class="categories-icon" style="text-align: center;">
											<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/${item.UrunGorselAdi}`" class="img-fluid">
										</div>
									</div>
									<div class="categories-content" :style="CardStyleObject">
										<h3 style="text-align: center; font-size: 16px!important;" :style="CardStyleObject">{{item.UrunAdi}}</h3>
									</div>
								</div>
							</div>							
						</template>
					</div>
				</div>
			</div>
		</section>

		<section v-if="getRol =='teacher' && OgrenimAraclari.length > 0" class="topcategory-sec">
			<div class="container">
				<div class="header-two-title text-center" data-aos="fade-up">
					<p class="tagline" style="margin-bottom: -1rem;" :style="Text1StyleObject">Platform Reports</p>
					<!-- <h2>Top Category</h2> -->
					<div class="header-two-text">
						<!-- <p class="mb-0">Lorem ipsum dolor sit amet</p> -->
					</div>
				</div>
				<div class="top-category-group">
					
					<div class="row" style="justify-content: center;">
						<span v-if="!Hazir" class="loader"></span>
						<!-- <template v-if="Hazir && OgrenimAraclari.length > 0"> -->
						<template v-if="(Hazir && OgrenimAraclari.length > 0)">
							<div v-for="(item) in OgrenimAraclari" :key="`l-`+item.UrunId" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-flex" data-aos="fade-down">
								<div class="categories-item flex-fill" :style="CardStyleObject" 
								@click="item.UrunId == 10 ? RLPModalGosterKapat(item) : git_LearningTools(item)">
									<div style="height: 100px;">	
										<div class="categories-icon" style="text-align: center;">
											<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/${item.UrunGorselAdi}`" class="img-fluid">
										</div>
									</div>
									<div class="categories-content" :style="CardStyleObject">
										<h3 style="text-align: center; font-size: 16px!important;" :style="CardStyleObject">{{item.UrunAdi}}</h3>
									</div>
								</div>
							</div>							
						</template>
					</div>
				</div>
			</div>
		</section>

		<section v-if="getRol =='teacher' && DemoHesaplar.length > 0" class="topcategory-sec">
			<div class="container">
				<div class="header-two-title text-center" data-aos="fade-up">
					<p class="tagline" style="margin-bottom: -1rem;" :style="Text1StyleObject">In-Class Tools</p>
					<!-- <h2>Top Category</h2> -->
					<div class="header-two-text">
						<!-- <p class="mb-0">Lorem ipsum dolor sit amet</p> -->
					</div>
				</div>
				<div class="top-category-group">
					
					<div class="row" style="justify-content: center;">
						<span v-if="!Hazir" class="loader"></span>
						<!-- <template v-if="Hazir && OgrenimAraclari.length > 0"> -->
						<template v-if="getRol =='teacher' && (Hazir && DemoHesaplar.length > 0)">
							<!-- <div v-for="(index,item) in DemoHesaplar" :key="`d-`+item.UrunId" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-flex" data-aos="fade-down"> -->
							<div v-for="(item, index) in DemoHesaplar" :key="`d-`+index" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 d-flex" data-aos="fade-down">
								<div class="categories-item in-class flex-fill" :style="CardStyleObject" 
								@click="git_LearningToolsDemo(item.UrunId,item.DemoHesap, item.DemoHesapSifre)">
									<div style="height: 100px;">
	
										<div class="categories-icon" style="text-align: center;">
											<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/${item.UrunGorselAdi}`" class="img-fluid">
										</div>
									</div>
									<div class="categories-content" :style="CardStyleObject">
										<h3 style="text-align: center; font-size: 16px!important;" :style="CardStyleObject">In-Class</h3>
										<h3 style="text-align: center; font-size: 16px!important; margin-top:25px" :style="CardStyleObject">{{item.UrunAdi}}</h3>
										<h3 v-show ="item.SinifSeviye != null" style="text-align: center; font-size: 16px!important; margin-top:20px" :style="CardStyleObject">GRADE {{item.SinifSeviye}}</h3>
										<h3 v-show ="item.SinifSeviye == null" style="text-align: center; font-size: 16px!important; margin-top:20px" :style="CardStyleObject">ALL GRADES</h3>
									</div>
								</div>
							</div>							
						</template>
					</div>
				</div>
			</div>
		</section>

		


		<div v-if="Modal" class="modal fade show" id="withdraw-request" style="display: block;" aria-modal="true"  role="dialog">
			<div class="modal-dialog modal-dialog-centered withdraw-modal">
				<div class="modal-content">
					<div class="page-wrapper-new p-0">
						<div class="content" style="min-height: 184.062px;">
							<div class="modal-header border-0 custom-modal-header">
								<div class="page-title">
									<h4>Richmond Learning Platform Aktivasyon Adımları</h4>
								</div>
								<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click.prevent="RLPModalGosterKapat()">
									<i class="feather-x"></i>
								</button>
							</div>

							<div class="modal-body custom-modal-body">
								<div class="col-md-12 mt-1">
									<template v-if="this.rlpCode != null && this.rlpCode != '###'">
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">1.</b> Platforma ilk defa erişiyorsanız, öncelikle aşağıdaki <b>"Kodu Kopyala"</b> butonuna basarak kitap kodunuzu kopyalayınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">2.</b> Altta gördüğünüz <b>"Richmond Learning Platform</b> simgesine tıklayınız ve siteye geçiş yapınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">3.</b> Ekranda <b>"MY PRODUCTS"</b> başlığı altında bulunan <b>"ADD ACCESS CODE"</b> butonuna basın ve kopyaladığınız kodu <b>"Please Enter a Code"</b> alanına yapıştırınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">4.</b>	Kodu yapıştırdıktan sonra sağ alt bölümde görünen <b>"Add Product"</b> butonuna tıklayınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">5.</b>	Ardından ekranda göreceğiniz <b>"START"</b> butonuna tıklayınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">6.</b>	Artık hesabınızda kitabınız aktif edilmiştir. Platformu kullanmaya başlayabilirsiniz.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">7.</b>	Sonraki erişimlerinizde sadece <b>"Richmond Learning Platform"</b> butonuna basıp platformu kullanabilirsiniz.</p>
										<!-- <p style="margin: 5px 5px 5px 5px"> <b style="color:red">UYARI :</b> Yukarıdaki adımlar tamamlandıktan sonra bu işlemi bir daha yapmanıza gerek yoktur. 
											Aşağıda gördüğünüz Richmond Learning Platform simgesine tıklayarak sistemi kullanmaya devam edebilirsiniz.</p> -->
										</template>
										<template v-else-if="this.rlpCode == '###'">
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">1.</b> Platforma ilk defa erişiyorsanız altta gördüğünüz <b>"Richmond Learning Platform</b> simgesine tıklayınız ve siteye geçiş yapınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">2.</b> Ekranda <b>"MY PRODUCTS"</b> başlığı altında bulunan <b>"ADD ACCESS CODE"</b> butonuna basın ve kitabınızda ön kapak içinde bulunan kodu <b>"Please Enter a Code"</b> alanına yazınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">3.</b>	Kodu yazdıktan sonra sağ alt bölümde görünen <b>"Add Product"</b> butonuna tıklayınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">4.</b>	Ardından ekranda göreceğiniz <b>"START"</b> butonuna tıklayınız.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">5.</b>	Artık hesabınızda kitabınız aktif edilmiştir. Platformu kullanmaya başlayabilirsiniz.</p>
										<p style="margin: 5px 5px 5px 5px"><b style="color:red">6.</b>	Sonraki erişimlerinizde sadece <b>"Richmond Learning Platform"</b> butonuna basıp platformu kullanabilirsiniz.</p>
										<!-- <p style="margin: 5px 5px 5px 5px"> <b style="color:red">UYARI :</b> Yukarıdaki adımlar tamamlandıktan sonra bu işlemi bir daha yapmanıza gerek yoktur. 
											Aşağıda gördüğünüz Richmond Learning Platform simgesine tıklayarak sistemi kullanmaya devam edebilirsiniz.</p> -->
									</template>
								</div>

								<div class="col-md-12 mt-1" v-if="this.rlpCode != null && this.rlpCode != '###'">
									<div style="height:auto !important">
										<div class="row mt-3 mb-3">
										<div class="col-8">
											<p style="margin: 5px 5px 5px 5px" ref="code" v-on:focus="$event.target.select()" >{{rlpCode}}</p>
											<input type="hidden" id="rlp-code" :value="rlpCode">
										</div>
										
										<div class="col-4">                      
											<button type="button" @click="copyCode()" class="btn btn-primary">Kodu Kopyala</button>
										</div>
										</div>                    
									</div>
								</div>

								<hr>
								<div class="row" style="height:10px"></div>

								<div class="top-category-group">					
									<div class="row" style="justify-content: center;">
										<div class="col-6 d-flex" data-aos="fade-down">
											<div class="categories-item flex-fill" :style="CardStyleObject" @click="git_LearningTools(10) ">
												<div style="height: 145px;">
				
													<div class="categories-icon" style="text-align: center;" >
														<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/rlp.png`" class="img-fluid">
													</div>
												</div>
											</div>
										</div>	
										<div class="col-6 d-flex" data-aos="fade-down" v-if="this.rlpCode != null && this.rlpCode != '###'">
											<div class="categories-item flex-fill" :style="CardStyleObject" style="height: 145px !important;" >
												<div style="height: 145px !important;">
													<a :href="`https://www.youtube.com/embed/5VS7u30m_Gc?si=2K_RXLa5Y_u_L64y`" target="blank">					
														<div class="categories-icon" style="text-align: center;">
															<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/rlp-youtube.png`" class="img-fluid"
															style="height: 138px; margin-top: 4px;">
														</div>
													</a>
												</div>
											</div>
										</div>	

										<div class="col-6 d-flex" data-aos="fade-down" v-if="this.rlpCode == '###'">
											<div class="categories-item flex-fill" :style="CardStyleObject" style="height: 145px !important;" >
												<div style="height: 145px !important;">
													<a :href="`https://www.youtube.com/embed/O2x4o_LeEqY?si=ctl_x10KvOEDzTVe`" target="blank">
				
														<div class="categories-icon" style="text-align: center;">
															<img :src="`https://storage.googleapis.com/schoollms/img/learningtools/rlp-youtube.png`" class="img-fluid"
															style="height: 138px; margin-top: 4px;">
														</div>
													</a>														
												</div>
											</div>
										</div>	
									</div>
								</div>	

								<div  class="col-lg-12" data-aos="fade-up" style="margin-bottom: -20px;">
									<div class="about-button  more-details text-center">
										<button class="btn btn-primary btn-start THMbutton THMbuttonShadow" @click="RLPModalGosterKapat()"
										:style="Button1StyleObject">Close 										
										</button>										
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<div v-if="Modal" class="modal-backdrop fade show"></div>

	</div>
</template>

<script>
import {mapGetters} from "vuex";
import LmsService from '@/services/lms.service';
// import CryptoJS from "crypto-js";
import {gitLearningTools} from "../global/go.learning.tools";


export default {
	// eslint-disable-next-line vue/multi-word-component-names
	name: "learningTools",
	data() {
		return {
			Hazir : false,
			// SinifSeviye: null,
            // SinifSube: null,
			// OgretmenSinifSeviyeleri: [],
			// OgretmenSinifSubeIdleri: [],
			// Rol: null,
			OgrenimAraclari: [],
			DemoHesaplar: [],
			Modal: false,
			rlpCode: null,
			LearningObje: null
			
		};
	},
	beforeMount() {
		this.IlkYukleme();
	},

	computed:{
		...mapGetters(['getKullaniciDetaylari','getSinifSeviye','getSinifSube','getKampusTipi','getKampusAdi','getKampusId','getOkulId','getSinifId',
		'getOkulAdi','getRol','getOgretmenSinifSeviyeleri','getOgretmenSinifSubeIdleri','CardStyleObject','Text1StyleObject','Button1StyleObject']),

	},
	methods: {
		copyCode(){
			let testingCodeToCopy = document.querySelector('#rlp-code')
			testingCodeToCopy.setAttribute('type', 'text') 
			testingCodeToCopy.select()

			// try {
				document.execCommand('copy');
				// var successful = document.execCommand('copy');
				// var msg = successful ? 'successful' : 'unsuccessful';
			//   alert('Testing code was copied ' + msg);
			// } catch (err) {
			//   alert('Oops, unable to copy');
			// }

			/* unselect the range */
			testingCodeToCopy.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},
        async IlkYukleme(){

            if (this.getKullaniciDetaylari) {
				this.rlpCode = this.getKullaniciDetaylari.rlp_code ? this.getKullaniciDetaylari.rlp_code : '###' //null
				// this.SinifSube = 
				// 	this.getKullaniciDetaylari.organization.find(x => x.type === 'grade') ? 
				// 	this.getKullaniciDetaylari.organization.find(x => x.type === 'grade').name : 0;

				// this.SinifSeviye = this.getSinifSeviye //this.SinifSube.split('-')[0] 

				// this.KampusTipi = this.getKullaniciDetaylari.organization.find(x => x.type === 'campus').school_type;
				// this.KampusAdi = this.getKullaniciDetaylari.organization.find(x => x.type === 'campus').name;
				// this.KampusId = this.getKullaniciDetaylari.organization.find(x => x.type === 'campus').id;
				// this.OkulId = this.getKullaniciDetaylari.organization.find(x => x.type === 'main').id;
				// this.OkulAdi = this.getKullaniciDetaylari.organization.find(x => x.type === 'main').name;
				// this.Rol = this.getKullaniciDetaylari.role_type;


				// const OgretmenSinifSeviyeleri = this.getKullaniciDetaylari.organization.filter((x) => x.type === "grade")
				// for (let key in OgretmenSinifSeviyeleri){
				// 	this.OgretmenSinifSeviyeleri.push(OgretmenSinifSeviyeleri[key].name.split("-")[0])
				// 	this.OgretmenSinifSubeIdleri.push(OgretmenSinifSeviyeleri[key].id)
				// }
				// this.OgretmenSinifSeviyeleri = [...new Set(this.OgretmenSinifSeviyeleri)] 
				// this.OgretmenSinifSubeIdleri = [...new Set(this.OgretmenSinifSubeIdleri)] 
				await this.OgrenimAraclariGetir()
        	}


		},

		async OgrenimAraclariGetir(){
			let Hata = null
			try {
				let SinifSubeIdler, SinifSeviyeler 
				if (this.getRol == 'teacher'){
					if(this.getOgretmenSinifSubeIdleri.length > 0){
						SinifSubeIdler = this.getOgretmenSinifSubeIdleri.map(value => ({ SinifId: value })); // anahtar adı olmayan listeye anahtar atama
					}

					if(this.getOgretmenSinifSeviyeleri.length > 0){
						SinifSeviyeler = this.getOgretmenSinifSeviyeleri.map(value => ({ SinifSeviye: value })); // anahtar adı olmayan listeye anahtar atama
					}



				} else{
					SinifSubeIdler = [{SinifId: this.getSinifId}]
					SinifSeviyeler = [{SinifSeviye: this.getSinifSeviye}]

				}

				const data = {
					OkulId: this.getOkulId,
					KampusId: this.getKampusId,
					SinifSeviye: SinifSeviyeler,
					SinifId: SinifSubeIdler,
				}	

				const dataInClass = {
					OkulId: this.getOkulId,
					SinifSeviye: SinifSeviyeler,
				}

				Hata = 1
				this.$store.commit('setLoading', true)
				const resData = await LmsService.OgrenimAraclariGetir(data)
				this.OgrenimAraclari = resData
				Hata = 2
				const resData1 = await LmsService.DemoHesaplariGetir(dataInClass)
				this.DemoHesaplar = resData1
                this.$store.commit('setLoading', false)
				this.Hazir = true
			} catch (error) {
				this.Hazir = true

                this.$store.commit('setLoading', false)
				this.$toast.open({
					message: (Hata == 1 )?"Lerarning Tools Araçları hatası!" : "InClass Araçları hatası!",
					type: "error",
					duration: 3000,
					dismissible: true,
					position : 'top'
				})
				return
			}
		},

		activated() {
			

		},
		created () {
		},

		git_LearningToolsDemo(UrunId, DemoHesap, DemoHesapSifre){
			const demoQuery = `?username=${btoa(DemoHesap)}&password=${btoa(DemoHesapSifre)}`;
			let url
			if (UrunId == 2) { url = "https://www.kidzwonder.com/"+demoQuery}
			if (UrunId == 3 || UrunId == 4) {url = "https://www.hexagonia.com.tr/"+demoQuery}
			if (UrunId == 5) {url = "https://englishplaybox.net/#/"+demoQuery}
			window.open(url);
		},

		async git_LearningTools(item) {
			if(item==10){ // RLP ise
				item = this.LearningObje
			}
			this.Modal = false
			gitLearningTools(item.UrunId, item.SecretKey, item.OgrenciLink, item.OgretmenLink)
		},

		// async git_LearningTools(UrunId) {
		// 	this.Modal = false
		// 	const KullaniciDetaylari = await this.getKullaniciDetaylari;

		// 	let Siniflar =[]
		// 	const Filter = KullaniciDetaylari.organization.filter((x) => x.type === "grade")
		// 	for (let key in Filter){
		// 		const Sinif = {grade: parseInt(Filter[key].name.split('-')[0]), branch: Filter[key].name}
		// 		Siniflar.push(Sinif)
		// 	}

		// 	let url, cokluSinif, sadeceSube
		// 	let	secretKey = "HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8";
		// 	//HLL
		// 	if (UrunId == 1) {
		// 		url ="https://www.hlllogin.com/#/sso/?q=" 
		// 		cokluSinif = true
		// 	}

		// 	//KW
		// 	if (UrunId == 2) {
		// 		url ="https://www.kidzwonder.com/#/login?sso="
		// 		sadeceSube = true
		// 	} 
			
		// 	//HEXAGONIA
		// 	if (UrunId == 3 || UrunId == 4)	{
		// 		url ="https://www.hexagonia.com.tr/?sso=" 	
		// 		sadeceSube = true
		// 	}			
			
		// 	//EPB
		// 	if (UrunId == 5) {
		// 		const epbQuery = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
		// 		url ="https://englishplaybox.net/#/" 
		// 		window.open(url+epbQuery);
		// 	}
			
		// 	//MYEDUCLASS		
		// 	if (UrunId == 6) {
		// 		url ="https://lms.myeduclass.com/#/?sso=" 
		// 		sadeceSube = true
		// 	}			
			
		// 	//MYEDUASSESSMENT
		// 	if (UrunId == 7){ 
		// 		//url = this.getRol == 'student' ? "https://www.myeduassessment.com/#/login" : "https://report.myeduassessment.com/#/login"
		// 		const myEduAssessmentQuery = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
		// 		url ="https://www.myeduassessment.com/#/login" 	
		// 		window.open(url+myEduAssessmentQuery);
		// 		return				
		// 	}

		// 	//NOM
		// 	if (UrunId == 8){ 
		// 		secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
		// 		url ="https://service.ueslms.com/#/nom/?sso="
		// 		sadeceSube = true
		// 	}

		// 	//RAZ PLUS
		// 	if (UrunId == 9){ 
		// 		secretKey = "DZYQSbQQKmruR4ZYOLD%s7163BZjoyViqF7gWy.A6Gd9JAyXCL!eNGsrEJVcPUe";
		// 		url ="https://service.ueslms.com/#/raz-plus/?sso=" 
		// 		sadeceSube = true
		// 	}

		// 	//RLP
		// 	if (UrunId == 10){ 
		// 		secretKey = "VswFYGzh2k45N7Q8R9@TBuCVexFY.G2J3K4N6p7Q%9SATB-VdWeXFZHJ3m5N";
		// 		url ="https://service.ueslms.com/#/rlp/?sso=" 
		// 		cokluSinif = true
		// 	}

		// 	//EFS+
		// 	if (UrunId == 14) { 
		// 		secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
		// 		url ="https://service.ueslms.com/#/efs/?sso=" 
		// 		cokluSinif = true
		// 	}

		// 	//MANENO
		// 	if (UrunId == 16) { 
		// 		secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
		// 		url ="https://service.ueslms.com/#/maneno/?sso=" 
		// 		sadeceSube = true
		// 	}


        //     var studentData = {
        //         school_id:  KullaniciDetaylari.organization.find(x => x.type === 'main').id,		// Değiştirmeyiniz
        //         campus_id: KullaniciDetaylari.organization.find(x => x.type === 'campus').id, 		// Int, Kampüs ID, MEB Okul ID olabilir
        //         campus_name: KullaniciDetaylari.organization.find(x => x.type === 'campus').name,   // String olmalı
        //         first_name: KullaniciDetaylari.first_name,              							// String olmalı
        //         last_name: KullaniciDetaylari.last_name,            								// String olmalı
        //         username: KullaniciDetaylari.email,           										// String olmalı
        //         roleType: this.getRol,            													// Değiştirmeyiniz.
        //         class: cokluSinif == true ? Siniflar : this.getSinifSeviye,                       	// Seviye => int olmalı
        //         branch: sadeceSube == true ? this.getSinifSube.split('-')[1] : this.getSinifSube,                    										// Şube => String olmalı
        //     }
        //     var textJson = JSON.stringify(studentData);
        //     var uriText = decodeURIComponent(textJson)
        //     var ciphertext = CryptoJS.AES.encrypt(uriText, secretKey).toString();
        //     url = url + btoa(ciphertext);
		// 	window.open(url);

        // },


		RLPModalGosterKapat(item){
			if(this.getRol == 'teacher'){
				gitLearningTools(item.UrunId, item.SecretKey, item.OgrenciLink, item.OgretmenLink)
				return
			} 

			if (this.Modal == false) this.LearningObje = item
			this.Modal = !this.Modal
		},
    


	}
}
</script>

<style scoped>


</style>
